import FilesContainer from "./components/FilesContainer";

const ViewDocumentsContainer = ({customBaseDetailPath}) => {
  return (
    <div className="h-full bg-white overflow-y-auto">
      <FilesContainer customBaseDetailPath = {customBaseDetailPath}/>
    </div>
  );
};

export default ViewDocumentsContainer;
